<template>
  <div class="row">
    <div class="col-xl-6 col-lg-6">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap align-items-center">
            <div class="mr-auto">
              <p class="text-uppercase text-dark font-weight-bold mb-1">
                {{ $t("sms.votreSolde") }}
              </p>
              <p class="text-gray-5 mb-0">{{ $t("sms.nbrSmsRestant") }}</p>
            </div>
            <p
              class="text-success font-weight-bold font-size-24 mb-0"
              v-if="solde.sms.solde > 100"
            >
              {{ solde.sms.solde }}
            </p>
            <p class="text-danger font-weight-bold font-size-24 mb-0" v-else>
              {{ solde.sms.solde }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-wrap align-items-center">
            <div class="mr-auto">
              <p class="text-uppercase text-dark font-weight-bold mb-1">
                {{ $t("sms.nomlExpediteur") }}
              </p>
              <p class="text-gray-5 mb-0">{{ $t("sms.desclExpediteur") }}</p>
            </div>
            <p class="text-success font-weight-bold font-size-24 mb-0">
              {{ solde.sms.senderName }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6">
      <h2 class="badge-example">{{ $t("sms.gererListeDistinateurs") }}</h2>

      <div class="card">
        <div class="card-header">
          <div class="cui__utils__heading mb-0">
            <strong>{{ $t("sms.envoyerDesSms") }}</strong>
          </div>
        </div>
        <div class="card-body">
          <a-form :form="form" class="card-header p-2" @submit="sendSms">
            <div class="row">
              <div class="col-md-12">
                <a-checkbox
                  :checked="checked"
                  @change="handleSelectAll"
                  class="font-weight-bold mb-2"
                >
                  {{ $t("sms.selectAll") }}
                </a-checkbox>
                <div>
                  <label class="typo__label">{{
                    $t("sms.selectionnerClases")
                  }}</label>
                  <multiselect
                    v-model="value"
                    :placeholder="$t('sms.selectionnerClases')"
                    :selectLabel="$t('sms.pressEnterToSelect')"
                    :options="classroomList"
                    :custom-label="customLabel"
                    :close-on-select="false"
                    :preserve-search="true"
                    :maxHeight="700"
                    @input="handleChange"
                    @remove="handleRemove"
                    label="classRoomName"
                    track-by="classRoomName"
                    :preselect-first="true"
                    :multiple="true"
                  >
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="align-text-top">
                          {{ props.option.classRoomName }}
                        </span>
                        <br /><span class="option__small font-size-12"
                          >{{ props.option.students.length }}
                          {{ $t("menu.eleves") }}</span
                        >
                      </div>
                    </template>

                    <template slot="noOptions">
                      {{ $t("sms.noOptions") }}
                    </template>
                  </multiselect>
                  <!-- <pre class="language-json"><code>{{ value  }}</code></pre>-->
                </div>
              </div>
              <div class="col-md-12 mt-3">
                <label class="typo__label">{{
                  $t("sms.entrerNumerosSpecifiques")
                }}</label>
                <a-tooltip :title="$t('sms.entrerNumerosSpecifiquesDesc')">
                  <a-icon
                    class="pl-2"
                    type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)"
                  />
                </a-tooltip>

                <a-form-item>
                  <a-textarea
                    @change="handleCustomNumbersChange"
                    v-model="customNumbers"
                    placeholder="+21620111532,+21650215253,+21697147895"
                    allow-clear
                  >
                  </a-textarea>
                  <span class="text-danger">
                    {{ customNumbersValidator }}
                  </span>
                </a-form-item>
              </div>
              <div class="col-md-12">
                <label class="typo__label">{{ $t("sms.categorieTag") }}</label>
                <a-tooltip :title="$t('sms.categorieTagDesc')">
                  <a-icon
                    class="pl-2"
                    type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)"
                  />
                </a-tooltip>
                <a-form-item>
                  <a-select
                    mode="tags"
                    style="width: 100%"
                    :placeholder="$t('sms.saisirCategorieTag')"
                    v-decorator="['tags']"
                  >
                    <a-select-option key="parent">
                      {{ $t("sms.parents") }}
                    </a-select-option>
                    <a-select-option key="personnel">
                      {{ $t("sms.personnel") }}
                    </a-select-option>
                    <a-select-option key="Sanction">
                      {{ $t("sms.sanction") }}
                    </a-select-option>
                    <a-select-option key="Bulletin">
                      {{ $t("sms.bulletin") }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-12 mt-3">
                <label class="typo__label"
                  >{{ $t("sms.contenueVotreMessage") }}
                </label>
                <a-form-item>
                  <a-textarea
                    v-model="message"
                    @change="smsNumber"
                    v-decorator="[
                      'message',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.smsContenue'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('sms.contenueMessage')"
                    :auto-size="{ minRows: 5, maxRows: 10 }"
                    allow-clear
                  />
                </a-form-item>
              </div>
              <div class="col-md-12">
                <a-button
                  type="primary"
                  style="width: 100%"
                  htmlType="submit"
                  size="large"
                  :loading="loadingSms"
                  :disabled="loadingSms"
                  :class="{
                    disabledPack: !btnAccessGetter.includes('sendSmsClass'),
                  }"
                  icon="tags"
                  :ghost="false"
                >
                  {{ $t("sms.envoyer") }}
                </a-button>
              </div>
            </div>
          </a-form>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6">
      <h2 class="badge-example">{{ $t("sms.listeFinale") }}</h2>
      <div class="card">
        <div class="card-body">
          <div :class="$style.head">
            <div :class="$style.headItem" class="mb-3 pr-3">
              <div :class="$style.headIcon" class="bg-light text-dark mr-3">
                <i class="fa fa-comments font-size-18" />
              </div>
              <div>
                <div class="text-uppercase text-muted text-nowrap">
                  {{ $t("sms.nombreSms") }}
                </div>
                <div class="font-weight-bold text-dark">{{ totalSms }}</div>
              </div>
            </div>
            <div :class="$style.headItem" class="mb-3">
              <div :class="$style.headIcon" class="bg-light text-dark mr-3">
                <i class="fa fa-edit font-size-18" />
              </div>
              <div>
                <div class="text-uppercase text-muted text-nowrap">
                  {{ $t("sms.nombreCaracteres") }}
                </div>
                <div class="font-weight-bold text-dark">
                  {{ message.length }}
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <a-checkbox-group
              class="m-2"
              v-model="checkboxValue"
              name="checkboxgroup"
              :options="plainOptions"
              @change="onChange"
            />
            <a-table
              :columns="columns"
              :dataSource="tableData"
              :class="$style.table"
              :pagination="pagination"
              :rowKey="(record, index) => record._id || record.customPhone || 'row-' + index"
            >
              <template slot="parent" slot-scope="text, record">
                <div v-if="record.customPhone">
                  <span
                    v-if="checkboxValue.includes('custom')"
                    class="font-weight-bold"
                    >- - -</span
                  >
                </div>
                <div v-else-if="record.father" class="d-flex flex-column">
                  <div v-if="record.father && checkboxValue.includes('father')" class="mb-1">
                    <a-checkbox
                      :checked="getStudentParentSelection(record._id, 'father')"
                      @change="(e) => handleStudentParentChange(record._id, 'father', e.target.checked, true)"
                    >
                      <span v-if="record.father.firstName || record.father.lastName">
                        {{ formatFirstMiddleLast(record.father) }}
                        <a-tag color="blue" class="ml-2">{{ $t("sms.pere") }}</a-tag>
                      </span>
                      <span v-else>
                        <a-tag color="blue">{{ $t("sms.pere") }}</a-tag>
                      </span>
                    </a-checkbox>
                  </div>
                  <div v-if="record.mother && checkboxValue.includes('mother')" class="mb-1">
                    <a-checkbox
                      :checked="getStudentParentSelection(record._id, 'mother')"
                      @change="(e) => handleStudentParentChange(record._id, 'mother', e.target.checked, true)"
                    >
                      <span v-if="record.mother.firstName || record.mother.lastName">
                        {{ formatFirstMiddleLast(record.mother) }}
                        <a-tag color="pink" class="ml-2">{{ $t("sms.mere") }}</a-tag>
                      </span>
                      <span v-else>
                        <a-tag color="pink">{{ $t("sms.mere") }}</a-tag>
                      </span>
                    </a-checkbox>
                  </div>
                  <div v-if="record.guardian && checkboxValue.includes('guardian')" class="mb-1">
                    <a-checkbox
                      :checked="getStudentParentSelection(record._id, 'guardian')"
                      @change="(e) => handleStudentParentChange(record._id, 'guardian', e.target.checked, true)"
                    >
                      <span>
                        {{ formatFirstMiddleLast(record.guardian) }}
                        <a-tag color="green" class="ml-2">{{ $t("sms.guardian") }}</a-tag>
                      </span>
                    </a-checkbox>
                  </div>
                </div>
              </template>
              <template slot="phone" slot-scope="text, record">
                <div v-if="record.customPhone">
                  <span
                    v-if="checkboxValue.includes('custom')"
                    class="font-weight-bold"
                    >{{ record.customPhone }}</span
                  >
                  <a-tag v-if="checkboxValue.includes('custom') && isDuplicatePhone(record.customPhone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                </div>

                <div v-else-if="record.father" class="d-flex flex-column">
                  <div
                    v-if="record.father && checkboxValue.includes('father')"
                    :class="{
                      'text-danger': record.father.phone.includes('invalide'),
                      'font-weight-bold': getStudentParentSelection(record._id, 'father'),
                      'text-muted': !getStudentParentSelection(record._id, 'father'),
                    }"
                    :style="!getStudentParentSelection(record._id, 'father') ? 'text-decoration: line-through; opacity: 0.5;' : ''"
                    class="mb-1"
                  >
                    {{ record.father.phone }}
                    <a-tag v-if="isDuplicatePhone(record.father.phone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                  </div>
                  <div
                    v-if="record.mother && checkboxValue.includes('mother')"
                    :class="{
                      'text-danger': record.mother.phone.includes('invalide'),
                      'font-weight-bold': getStudentParentSelection(record._id, 'mother'),
                      'text-muted': !getStudentParentSelection(record._id, 'mother'),
                    }"
                    :style="!getStudentParentSelection(record._id, 'mother') ? 'text-decoration: line-through; opacity: 0.5;' : ''"
                    class="mb-1"
                  >
                    {{ record.mother.phone }}
                    <a-tag v-if="isDuplicatePhone(record.mother.phone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                  </div>
                  <div
                    v-if="record.guardian && checkboxValue.includes('guardian')"
                    :class="{
                      'text-danger': record.guardian.phone.includes('invalide'),
                      'font-weight-bold': getStudentParentSelection(record._id, 'guardian'),
                      'text-muted': !getStudentParentSelection(record._id, 'guardian'),
                    }"
                    :style="!getStudentParentSelection(record._id, 'guardian') ? 'text-decoration: line-through; opacity: 0.5;' : ''"
                    class="mb-1"
                  >
                    {{ record.guardian.phone }}
                    <a-tag v-if="isDuplicatePhone(record.guardian.phone)" color="orange" class="ml-1">{{ $t("sms.duplicateTag") }}</a-tag>
                  </div>
                </div>
              </template>
              <div
                slot="filterDropdown"
                slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column,
                }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="(c) => (searchInput = c)"
                  :placeholder="`${$t('personnel.chercher')} ${column.title}`"
                  :value="selectedKeys[0]"
                  style="width: 188px; margin-bottom: 8px; display: block"
                  @change="
                    (e) =>
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                  "
                  @pressEnter="
                    () => handleSearch(selectedKeys, confirm, column.dataIndex)
                  "
                />
                <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="
                    () => handleSearch(selectedKeys, confirm, column.dataIndex)
                  "
                  >{{ $t("paiement.chercher") }}</a-button
                >
                <a-button
                  size="small"
                  style="width: 90px"
                  @click="() => handleReset(clearFilters)"
                  >{{ $t("action.reinitialiser") }}</a-button
                >
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <sms-confirm-modal
      :visible="showConfirmModal"
      :loading="loadingSms"
      :summary="finalSmsSummary"
      :totalSms="totalSms"
      @confirm="confirmSend"
      @cancel="showConfirmModal = false"
    />
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import moment from "moment";
import { mapState, mapActions, mapGetters } from "vuex";
import { getBuildingCountryCode } from "@/utilities/countrySpecific";
import { normalizePhone, normalizeParentPhones } from "@/utilities/phone";
import SmsConfirmModal from "../components/SmsConfirmModal.vue";

export default {
  components: { SmsConfirmModal },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters("settings", ["btnAccessGetter"]),
    columns() {
      return [
        {
          title: this.$t("sms.destinataire"),
          dataIndex: "father",
          key: "parent",
          scopedSlots: {
            customRender: "parent",
          },
        },
        {
          title: this.$t("sms.telephone"),
          dataIndex: "father.phone",
          class: "bg-transparent text-gray-6",
          scopedSlots: {
            customRender: "phone",
          },
        },
      ];
    },
    plainOptions() {
      return [
        { label: this.$t("sms.pere"), value: "father" },
        { label: this.$t("sms.mere"), value: "mother" },
        { label: this.$t("sms.guardian"), value: "guardian" },
        { label: this.$t("sms.specifique"), value: "custom" },
      ];
    },
    duplicatePhonesSet() {
      const count = {};
      const includeCustom = this.checkboxValue.includes("custom");
      this.tableData.forEach((item) => {
        if (item.customPhone) {
          if (includeCustom && this.validPhoneNumber(item.customPhone)) {
            const p = item.customPhone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
          return;
        }
        if (item._id && this.studentParentSelections[item._id]) {
          const s = this.studentParentSelections[item._id];
          if (s.father && item.father && this.validPhoneNumber(item.father.phone)) {
            const p = item.father.phone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
          if (s.mother && item.mother && this.validPhoneNumber(item.mother.phone)) {
            const p = item.mother.phone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
          if (s.guardian && item.guardian && this.validPhoneNumber(item.guardian.phone)) {
            const p = item.guardian.phone.toString().trim();
            count[p] = (count[p] || 0) + 1;
          }
        }
      });
      const duplicateSet = new Set();
      Object.keys(count).forEach((phone) => {
        if (count[phone] > 1) duplicateSet.add(phone);
      });
      return duplicateSet;
    },
  },
  created() {
    this.form = this.$form.createForm(this, { name: "sendSMSForm" });
    //get solde
    this.getSolde();
    apiClient
      .post("/students/filter", {
        query: {
          status: "active",
        },
        aggregation: [
          {
            $set: {
              classRoom: {
                $convert: {
                  input: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
                  to: "objectId",
                  onError: null,
                  onNull: null,
                },
              },
            },
          },
          {
            $set: {
              classRoomName: "$classRoom",
            },
          },
          {
            $lookup: {
              from: "classrooms",
              localField: "classRoom",
              foreignField: "_id",
              as: "classRoomName",
            },
          },
          {
            $lookup: {
              from: "parents",
              localField: "parent",
              foreignField: "_id",
              as: "parent",
            },
          },
          {
            $project: {
              _id: 1,
              idParent: { $arrayElemAt: ["$parent._id", 0] },
              father: { $arrayElemAt: ["$parent.father", 0] },
              mother: { $arrayElemAt: ["$parent.mother", 0] },
              guardian: { $arrayElemAt: ["$parent.guardian", 0] },
              classRoom: 1,
              firstName: 1,
              middleName: 1,
              lastName: 1,
              classRoomName: { $arrayElemAt: ["$classRoomName.name", 0] },
            },
          },
        ],
      })
      .then((res) => {
        const { data } = res;
        this.studentList = data.map((e) => {
          // numbers imported without country code get the building dial code
          normalizeParentPhones(e);
          let formatted = { ...e };
          if (e.father) {
            formatted.father.phone = !e.father?.phone
              ? "Pas de numéro"
              : !this.validPhoneNumber(e.father.phone)
              ? e.father.phone + " - invalide"
              : e.father.phone.toString();
          } else {
            formatted.father = {
              phone: "Pas de numéro - invalide",
              login: null,
            };
          }
          if (e.mother) {
            formatted.mother.phone = !e.mother?.phone
              ? "Pas de numéro"
              : !this.validPhoneNumber(e.mother.phone)
              ? e.mother.phone + " - invalide"
              : e.mother.phone.toString();
          } else {
            formatted.mother = {
              phone: "Pas de numéro - invalide",
              login: null,
            };
          }
          if (e.guardian && e.guardian.phone) {
            formatted.guardian = {
              ...e.guardian,
              phone: !this.validPhoneNumber(e.guardian.phone)
                ? e.guardian.phone + " - invalide"
                : e.guardian.phone.toString(),
            };
          } else {
            formatted.guardian = null;
          }
          return formatted;
        });

        // create classroom array
        const classRooms = _.mapValues(
          _.groupBy(this.studentList, "classRoomName"),
          (clist) => clist.map((elem) => _.omit(elem, "classRoomName"))
        );
        delete classRooms["undefined"];

        this.classroomList = [];
        for (const classRoomName of Object.keys(classRooms).sort()) {
          if (classRoomName !== "Non inscrit")
            this.classroomList.push({
              classRoomName,
              students: classRooms[classRoomName],
            });
        }
      })
      .catch((e) => {
        console.log(e);
        this.$message.error("Aucun élève est trouvé");
      })
      .finally(() => (this.loadingStudents = false));
  },
  data() {
    return {
      solde: {
        sms: {
          solde: "--",
          senderName: "EdTrust",
        },
      },
      message: "",
      loadingSms: false,
      loadingStudents: true,
      studentsData: [],
      classroomList: [],
      studentList: [],
      value: [],
      tableData: [],
      checkboxValue: [],
      totalSms: 0,
      customNumbers: "",
      customNumbersList: [],
      customNumbersValidator: "",
      pagination: {
        defaultPageSize: 8,
      },
      checked: false,
      studentParentSelections: {},
      showConfirmModal: false,
      finalSmsSummary: null,
      pendingSmsPayload: null,
    };
  },
  methods: {
    getSolde() {
      apiClient
        .get("/sms/solde")
        .then((res) => {
          this.solde = res.data;
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(e.response.data.message);
        })
        .finally(() => (this.loadingStudents = false));
    },
    moment,
    ...mapActions("settings", ["packHasBtnAccess"]),

    async sendSms(e) {
      e.preventDefault();
      if (!(await this.packHasBtnAccess("sendSmsClass"))) return;

      this.form.validateFieldsAndScroll((err, values) => {
        if (this.customNumbersValidator || err) return;

        const parentPhonesMap = new Map();
        const students = [];
        this.value.forEach((classe) => {
          students.push(...classe.students);
        });

        students.forEach((student) => {
          const selections = this.studentParentSelections[student._id];
          if (!selections || !student.idParent) return;

          if (!parentPhonesMap.has(student.idParent)) {
            parentPhonesMap.set(student.idParent, {
              _id: student.idParent,
            });
          }
          const parentEntry = parentPhonesMap.get(student.idParent);
          if (selections.father && student.father && student.father.phone) {
            parentEntry.father = { phone: student.father.phone.toString().trim() };
          }
          if (selections.mother && student.mother && student.mother.phone) {
            parentEntry.mother = { phone: student.mother.phone.toString().trim() };
          }
          if (selections.guardian && student.guardian && student.guardian.phone) {
            parentEntry.guardian = { phone: student.guardian.phone.toString().trim() };
          }
        });

        const parentPhones = Array.from(parentPhonesMap.values()).filter(
          (p) => p.father || p.mother || p.guardian
        );

        let targetArray = [];
        if (parentPhones.length > 0) {
          if (parentPhones.some((p) => p.father)) targetArray.push("father");
          if (parentPhones.some((p) => p.mother)) targetArray.push("mother");
          if (parentPhones.some((p) => p.guardian)) targetArray.push("guardian");
        }
        if (this.customNumbers && this.checkboxValue.includes("custom")) {
          targetArray.push("custom");
        }

        this.pendingSmsPayload = {
          target: targetArray,
          message: values.message,
          customNumbers: this.checkboxValue.includes("custom") ? this.customNumbers : "",
          total: this.totalSms,
          tags: values.tags,
          parents: parentPhones,
        };
        this.finalSmsSummary = this.computeFinalSmsSummary();
        this.showConfirmModal = true;
      });
    },
    confirmSend() {
      if (!this.pendingSmsPayload) return;
      this.loadingSms = true;
      apiClient
        .put("/sms", this.pendingSmsPayload)
        .then(() => {
          this.showConfirmModal = false;
          this.pendingSmsPayload = null;
          this.finalSmsSummary = null;
          this.getSolde();
          this.form.resetFields();
          this.value = [];
          this.tableData = [];
          this.customNumbers = "";
          this.customNumbersList = [];
          this.checkboxValue = [];
          this.checked = false;
          this.studentParentSelections = {};
          this.totalSms = 0;
          this.message = "";
          this.$message.success("SMS envoyé avec succeés");
        })
        .catch((e) => {
          console.log(e);
          switch (e.response?.status) {
            case 401:
              this.$message.warning(e.response?.data?.message);
              break;
            default:
              this.$message.error(e.response?.data?.message || "Erreur");
              break;
          }
        })
        .finally(() => (this.loadingSms = false));
    },
    computeFinalSmsSummary() {
      const seen = new Set();
      let totalInvalid = 0;
      let totalDuplicates = 0;
      const addPhone = (phone) => {
        if (!phone || phone.toString().includes("invalide") || !this.validPhoneNumber(phone)) {
          totalInvalid += 1;
          return null;
        }
        const p = phone.toString().trim();
        if (seen.has(p)) {
          totalDuplicates += 1;
          return null;
        }
        seen.add(p);
        return p;
      };

      const entries = [];
      const students = [];
      this.value.forEach((c) => students.push(...c.students));

      const parentName = (person, fallbackLabel) => {
        if (!person) return fallbackLabel;
        const n = this.formatFirstMiddleLast(person);
        return n || fallbackLabel;
      };

      students.forEach((student) => {
        const selections = this.studentParentSelections[student._id];
        if (!selections) return;

        if (selections.father && student.father?.phone) {
          const ph = addPhone(student.father.phone);
          if (ph) {
            entries.push({
              name: parentName(student.father, this.$t("sms.pere")),
              phones: [{ phone: ph, label: this.$t("sms.pere") }],
            });
          }
        }
        if (selections.mother && student.mother?.phone) {
          const ph = addPhone(student.mother.phone);
          if (ph) {
            entries.push({
              name: parentName(student.mother, this.$t("sms.mere")),
              phones: [{ phone: ph, label: this.$t("sms.mere") }],
            });
          }
        }
        if (selections.guardian && student.guardian?.phone) {
          const ph = addPhone(student.guardian.phone);
          if (ph) {
            entries.push({
              name: parentName(student.guardian, this.$t("sms.guardian")),
              phones: [{ phone: ph, label: this.$t("sms.guardian") }],
            });
          }
        }
      });

      if (this.checkboxValue.includes("custom") && this.customNumbersList?.length) {
        this.customNumbersList.forEach((item) => {
          const ph = addPhone(item.customPhone);
          if (ph) {
            entries.push({ name: this.$t("sms.specifique"), phones: [{ phone: ph, label: "" }] });
          }
        });
      }

      return {
        entries,
        totalValidPhones: seen.size,
        totalInvalid,
        totalDuplicates,
      };
    },
    recomputeTableData() {
      const students = [];
      this.value.forEach((classe) => {
        students.push(...classe.students);
      });
      this.tableData = students.concat(this.customNumbersList);
      this.smsNumber();
    },
    handleCustomNumbersChange() {
      if (!this.customNumbers || this.customNumbers.trim() === "") {
        this.customNumbersValidator = "";
        this.customNumbersList = [];
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "custom"
        );
        this.recomputeTableData();
        return;
      }
      if (!this.validCustomePhoneNumbers(this.customNumbers)) {
        this.customNumbersValidator =
          "format invalide,les numéros de téléphone doit être séparés par des virgules !";
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "custom"
        );
        this.smsNumber();
      } else {
        this.customNumbersValidator = "";
        this.customNumbersList = this.customNumbers
          .split(",")
          .map((e) => ({
            customPhone: normalizePhone(e),
          }))
          .filter((e) => e.customPhone);
        // Add custom checkbox if numbers exist
        if (
          this.customNumbersList.length > 0 &&
          !this.checkboxValue.includes("custom")
        ) {
          this.checkboxValue.push("custom");
        }
        // Remove custom checkbox if no numbers
        if (this.customNumbersList.length === 0) {
          this.checkboxValue = this.checkboxValue.filter(
            (val) => val !== "custom"
          );
        }
        this.recomputeTableData();
      }
    },
    smsNumber() {
      const uniquePhones = new Set();
      this.tableData.forEach((item) => {
        if (item.customPhone) {
          if (this.checkboxValue.includes("custom") && this.validPhoneNumber(item.customPhone)) {
            uniquePhones.add(item.customPhone.toString().trim());
          }
          return;
        }
        if (item._id && this.studentParentSelections[item._id]) {
          const selections = this.studentParentSelections[item._id];
          if (selections.father && item.father && this.validPhoneNumber(item.father.phone)) {
            uniquePhones.add(item.father.phone.toString().trim());
          }
          if (selections.mother && item.mother && this.validPhoneNumber(item.mother.phone)) {
            uniquePhones.add(item.mother.phone.toString().trim());
          }
          if (selections.guardian && item.guardian && this.validPhoneNumber(item.guardian.phone)) {
            uniquePhones.add(item.guardian.phone.toString().trim());
          }
        }
      });
      this.calculateSMSNumber(uniquePhones.size);
    },
    calculateSMSNumber(total) {
      if (this.isArabic(this.message))
        this.totalSms = Math.ceil(this.message.length / 66) * total;
      else this.totalSms = Math.ceil(this.message.length / 156) * total;
    },
    formatFirstMiddleLast(p) {
      if (!p) return "";
      const parts = [p.firstName, p.middleName, p.lastName]
        .map((x) => (x != null && String(x).trim() ? String(x).trim() : ""))
        .filter(Boolean);
      return parts.join(" ");
    },
    customLabel({ classRoomName }) {
      return `${classRoomName}`;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSelectAll(e) {
      this.checked = e.target.checked;

      this.value = e.target.checked ? [...this.classroomList] : [];
      const students = [];
      this.value.forEach((classe) => {
        students.push(...classe.students);
      });
      this.tableData = students.concat(this.customNumbersList);

      if (e.target.checked) {
        // Initialize parent selections for all students
        students.forEach((student) => {
          this.$set(this.studentParentSelections, student._id, {
            father: true,
            mother: true,
            guardian: !!student.guardian,
          });
        });
        // Ensure global checkboxes are checked
        if (students.length > 0) {
          if (!this.checkboxValue.includes("father")) this.checkboxValue.push("father");
          if (!this.checkboxValue.includes("mother")) this.checkboxValue.push("mother");
          if (students.some((s) => s.guardian) && !this.checkboxValue.includes("guardian")) {
            this.checkboxValue.push("guardian");
          }
        }
      } else {
        // Clear parent selections
        this.studentParentSelections = {};
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "father" && val !== "mother" && val !== "guardian"
        );
      }

      this.smsNumber();
    },
    handleChange(value) {
      const students = [];
      value.forEach((classe) => {
        students.push(...classe.students);
      });
      this.tableData = students.concat(this.customNumbersList);

      // Get current student IDs
      const currentIds = new Set(students.map((s) => s._id));

      // Initialize parent selections for newly added students
      students.forEach((student) => {
        if (!this.studentParentSelections[student._id]) {
          this.$set(this.studentParentSelections, student._id, {
            father: true,
            mother: true,
            guardian: !!student.guardian,
          });
        }
      });

      // Remove parent selections for deselected students
      const newSelections = {};
      Object.keys(this.studentParentSelections).forEach((studentId) => {
        if (currentIds.has(studentId)) {
          newSelections[studentId] = this.studentParentSelections[studentId];
        }
      });
      this.studentParentSelections = newSelections;

      // Ensure global checkboxes are checked when students are selected
      if (students.length > 0) {
        if (!this.checkboxValue.includes("father")) this.checkboxValue.push("father");
        if (!this.checkboxValue.includes("mother")) this.checkboxValue.push("mother");
        if (students.some((s) => s.guardian) && !this.checkboxValue.includes("guardian")) {
          this.checkboxValue.push("guardian");
        }
      } else {
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "father" && val !== "mother" && val !== "guardian"
        );
      }

      this.smsNumber();
    },

    handleRemove(removedOption, id) {
      console.log(`selectedOption ${removedOption} , id: ${id}`);
    },
    //a table
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    isArabic(text) {
      let pattern = /[\u0600-\u06FF\u0750-\u077F]/;
      return pattern.test(text);
    },
    //checkbot
    onChange(checkedValues) {
      const includeFather = checkedValues.includes("father");
      const includeMother = checkedValues.includes("mother");
      const includeGuardian = checkedValues.includes("guardian");

      // Get all students from selected classrooms
      const students = [];
      this.value.forEach((classe) => {
        students.push(...classe.students);
      });

      // Update all students' parent selections based on global checkboxes
      students.forEach((student) => {
        this.$set(this.studentParentSelections, student._id, {
          father: includeFather,
          mother: includeMother,
          guardian: includeGuardian && !!student.guardian,
        });
      });

      this.smsNumber();
    },
    validPhoneNumber(phone) {
      if (!phone) return false;
      const countryCode = getBuildingCountryCode();
      if (countryCode === "TN") {
        const regex = /^\+216[1-9]\d{7}$/;
        return regex.test(phone.toString().trim());
      }
      const regex = /^\+[1-9]\d{6,14}$/;
      return regex.test(phone.toString().trim());
    },
    validCustomePhoneNumbers(phones) {
      // numbers without country code get the building dial code
      return phones
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean)
        .every((p) => this.validPhoneNumber(normalizePhone(p)));
    },
    // Handle per-student parent checkbox changes
    handleStudentParentChange(studentId, parentType, checked, updateGlobal = false) {
      if (!this.studentParentSelections[studentId]) {
        this.$set(this.studentParentSelections, studentId, {
          father: false,
          mother: false,
          guardian: false,
        });
      }
      this.$set(this.studentParentSelections[studentId], parentType, checked);

      if (updateGlobal) {
        this.updateGlobalCheckboxes();
      }

      this.smsNumber();
    },
    // Update global checkboxes based on individual student selections
    updateGlobalCheckboxes() {
      const students = [];
      this.value.forEach((classe) => {
        students.push(...classe.students);
      });

      if (students.length === 0) {
        this.checkboxValue = this.checkboxValue.filter(
          (val) => val !== "father" && val !== "mother" && val !== "guardian"
        );
        return;
      }

      const updateParentCheckbox = (parentType) => {
        const allSelected = students.every((student) => {
          const selections = this.studentParentSelections[student._id];
          return selections && selections[parentType];
        });
        const someSelected = students.some((student) => {
          const selections = this.studentParentSelections[student._id];
          return selections && selections[parentType];
        });

        if (allSelected && !this.checkboxValue.includes(parentType)) {
          this.checkboxValue.push(parentType);
        } else if (!someSelected && this.checkboxValue.includes(parentType)) {
          this.checkboxValue = this.checkboxValue.filter((val) => val !== parentType);
        }
      };

      updateParentCheckbox("father");
      updateParentCheckbox("mother");
      updateParentCheckbox("guardian");
    },
    // Get per-student parent selection
    getStudentParentSelection(studentId, parentType) {
      if (!this.studentParentSelections[studentId]) return false;
      return this.studentParentSelections[studentId][parentType] || false;
    },
    isDuplicatePhone(phone) {
      if (!phone || phone.toString().includes("invalide")) return false;
      return this.duplicatePhonesSet.has(phone.toString().trim());
    },
  },
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
